// extracted by mini-css-extract-plugin
module.exports = {"articles":"Section4Cards_articles__BXG7B","article":"Section4Cards_article__zqmF5"};